import { Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/components/Page";
import MaintenanceStrategyTable from "@/components/Strategy/MaintenanceStrategyTable";

function KontrollpunktStrategyPage() {
  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Vedlikeholdsnivåer
      </Typography>
      <MaintenanceStrategyTable />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/strategi/inspection-point")({
  component: KontrollpunktStrategyPage,
});
